// extracted by mini-css-extract-plugin
export var active = "_20-7";
export var backButton = "_20-6";
export var clone = "_20-c";
export var collapseBar = "_20-g";
export var collapseMode = "_20-i";
export var dragHandle = "_20-a";
export var dropdownIcon = "_20-e";
export var hidden = "_20-o";
export var iconContainer = "_20-l";
export var iconSwapper = "_20-n";
export var navItem = "_20-4";
export var navItemIcon = "_20-d";
export var navProfile = "_20-5";
export var notificationDot = "_20-m";
export var optionsContainer = "_20-f";
export var primaryNav = "_20-0";
export var primaryTab = "_20-j";
export var secondaryNav = "_20-1";
export var selected = "_20-k";
export var settingsNav = "_20-2";
export var settingsNavItems = "_20-3";
export var show = "_20-b";
export var sideNav = "_20-h";
export var teamItem = "_20-8";
export var userProfileItem = "_20-9";